
import './owner.css';
import mockData from './mock-data.js';
import MockPanel from './widgets/mock-panel.vue';
import DialogNotice from './widgets/dialog-notice.vue';
import DialogConfirm from './widgets/dialog-confirm.vue';
import AccountMenu from './widgets/account-menu.vue';
import NoticePanel from './widgets/notice-panel.vue';
import MonthBoard from './widgets/month-board.vue';

export default {
  name: 'owner-shell',
  components: {
    MockPanel: MockPanel,
    DialogNotice: DialogNotice,
    DialogConfirm: DialogConfirm,
    AccountMenu: AccountMenu,
    NoticePanel: NoticePanel,
    MonthBoard: MonthBoard
  },
  data: function () {
    return {
      ownerName: '',
      ownerEmail: '',
      avatarUrl: '',
      facilityName: mockData.facilityName,
      unreadCount: 0,
      langOpen: false,
      contractLang: 'ja',
      emptyHint: '',
      majorChecking: true,
      majorNotice: null,
      majorAgreeLabel: '同意する',
      seenNoticeId: 0,
      noticeTimer: null,
      noticeTitle: '通知',
      noticeBody: '',
      confirmBody: '',
      monthBoardLive: false,
      monthBoardType: 'market_report',
      monthBoardFocusYear: 0,
      monthBoardFocusMonth: 0,
      ui: {
        notice: false,
        confirm: false,
        accountMenu: false,
        noticePanel: false,
        monthBoard: false
      }
    };
  },
  computed: {
    navProfile: function () {
      return this.$route.path === '/owner/profile';
    },
    navStay: function () {
      return this.$route.path !== '/owner/profile';
    },
    navContract: function () {
      return this.$route.path === '/owner/contract';
    },
    avatarStyle: function () {
      if (!this.avatarUrl) return {};
      return { backgroundImage: 'url(' + this.url(this.avatarUrl) + ')' };
    },
    showMockPanel: function () {
      if (this.$route && this.$route.query && (this.$route.query.mock === '1' || this.$route.query.mock === 'corp')) {
        return true;
      }
      try {
        var flag = window.localStorage && localStorage.getItem('_ownerUiMock');
        if (flag && flag !== '0' && flag !== 'false') {
          return true;
        }
      } catch (e) {}
      return false;
    },
    mockButtons: function () {
      var list = [
        { key: 'account-menu', label: '账号菜单' },
        { key: 'notice-panel', label: '通知面板' },
        { key: 'stay-sent', label: '试泊已提交' },
        { key: 'owner-stop', label: '换房东停更' },
        { key: 'bank-confirm', label: '改口座确认' },
        { key: 'month-board', label: '选月（看板）' },
        { key: 'download-done', label: '下载完成' },
        { key: 'empty-rooms', label: '空态：无房' },
        { key: 'empty-settlement', label: '空态：未公开清算' }
      ];
      var path = this.$route.path;
      if (path === '/owner' || path === '/owner/') {
        list.push({ key: 'collapse-rooms', label: '折叠民宿行' });
        list.push({ key: 'expand-rooms', label: '展开民宿行' });
      }
      if (path === '/owner/profile') {
        list.push({ key: 'profile-person', label: '个人资料卡' });
        list.push({ key: 'profile-corp', label: '企业资料卡' });
        list.push({ key: 'open-contract', label: '打开契约 PDF 页' });
      }
      if (path === '/owner/settlement') {
        list.push({ key: 'settlement-data', label: '有数据' });
        list.push({ key: 'settlement-empty', label: '还未公开' });
      }
      return list;
    }
  },
  created: function () {
    var cached = (window.S && S.get) ? S.get('_landlord') : null;
    if (cached) this.applyMe(cached);
    this.loadMe();
    this.loadRooms();
    this.loadUnreadCount();
    this.loadMajorGate(false);
    this.$eventBus.$on('owner-me-updated', this.applyMe);
    this.$eventBus.$on('owner-open-notices', this.openNotices);
    this.$eventBus.$on('owner-unread-query', this.publishUnread);
  },
  activated: function () {
    this.startNoticePoll();
    this.loadMajorGate(true);
  },
  deactivated: function () {
    this.stopNoticePoll();
  },
  beforeDestroy: function () {
    this.stopNoticePoll();
    this.$eventBus.$off('owner-me-updated', this.applyMe);
    this.$eventBus.$off('owner-open-notices', this.openNotices);
    this.$eventBus.$off('owner-unread-query', this.publishUnread);
  },
  methods: {
    applyMe: function (item) {
      if (!item) return;
      this.ownerName = item.name || ((item.lastname || '') + (item.firstname || ''));
      this.ownerEmail = item.email || item.username || '';
      this.avatarUrl = item.avatar_url || '';
    },
    loadMe: function () {
      var t = this;
      axios.get('landlord/me').then(function (res) {
        if (res.data.status == 1 && res.data.options && res.data.options.item) {
          t.applyMe(res.data.options.item);
        }
      });
    },
    loadRooms: function () {
      var t = this;
      axios.get('landlord/myRooms').then(function (res) {
        if (res.data.status == 1 && res.data.options && res.data.options.items && res.data.options.items.length) {
          t.facilityName = res.data.options.items[0].name || t.facilityName;
        }
      });
    },
    loadUnreadCount: function () {
      var t = this;
      axios.get('landlord/notices/unreadCount').then(function (res) {
        if (res.data.status == 1 && res.data.options) {
          var n = Number(res.data.options.count);
          t.unreadCount = isFinite(n) ? n : 0;
          t.publishUnread();
        }
      });
    },
    publishUnread: function () {
      this.$eventBus.$emit('owner-unread', this.unreadCount);
    },
    openNotices: function () {
      this.ui.noticePanel = true;
    },
    setContractLang: function (lang) {
      this.contractLang = lang === 'zh' ? 'zh' : 'ja';
      this.$eventBus.$emit('owner-contract-lang', this.contractLang);
    },
    onNoticeAcked: function (item) {
      this.loadUnreadCount();
      if (this.majorNotice && item && item.id === this.majorNotice.id) {
        this.majorNotice = null;
      }
      this.goFromNotice(item);
    },
    startNoticePoll: function () {
      this.stopNoticePoll();
      var shell = this;
      this.noticeTimer = setInterval(function () {
        shell.loadMajorGate(true);
      }, 25000);
    },
    stopNoticePoll: function () {
      clearInterval(this.noticeTimer);
      this.noticeTimer = null;
    },
    loadMajorGate: function (silent) {
      if (this._inactive) return;
      var t = this;
      axios.get('landlord/notices', { params: { tab: 'inbox' } }).then(function (res) {
        if (t._inactive) return;
        t.majorChecking = false;
        if (!(res.data && res.data.status == 1 && res.data.options)) return;
        var items = res.data.options.items || [];
        var revised = null;
        var popup = null;
        var i;
        for (i = 0; i < items.length; i++) {
          var row = items[i];
          if (!row) continue;
          if (!revised && row.type === 'settlement_revised') revised = row;
          if (!popup && (row.type === 'settlement_published' || row.type === 'important')) popup = row;
        }
        var hit = revised || popup;
        if (!hit) return;
        if (t.majorNotice && t.majorNotice.id === hit.id) return;
        if (!revised && hit.id <= t.seenNoticeId) return;
        t.majorAgreeLabel = hit.type === 'settlement_revised' ? '同意する' : '確認';
        t.majorNotice = hit;
      }).catch(function () {
        if (!silent) t.majorChecking = false;
      });
    },
    agreeMajor: function () {
      var t = this;
      var item = this.majorNotice;
      if (!item || !item.id) {
        this.majorNotice = null;
        return;
      }
      axios.post('landlord/notices/read/' + item.id).then(function (res) {
        if (res.data && res.data.status == 1) {
          t.seenNoticeId = item.id;
          t.majorNotice = null;
          t.loadUnreadCount();
          if (item.type === 'settlement_published' || item.type === 'settlement_revised') {
            t.goFromNotice(item);
          }
        }
      });
    },
    parseYearMonth: function (year, month) {
      var y = parseInt(year, 10);
      var m = parseInt(month, 10);
      if (!isFinite(y) || y <= 0 || !isFinite(m) || m < 1 || m > 12) return null;
      return { year: y, month: m };
    },
    openPubMonthBoard: function (pubType, year, month) {
      var t = this;
      this.monthBoardLive = true;
      this.monthBoardType = pubType;
      this.monthBoardFocusYear = year;
      this.monthBoardFocusMonth = month;
      var show = function () {
        t.ui.monthBoard = true;
      };
      if (this.ui.monthBoard) {
        this.ui.monthBoard = false;
        this.$nextTick(show);
      } else {
        show();
      }
    },
    goFromNotice: function (item) {
      if (!item) return;
      var payload = item.payload;
      if (!payload || typeof payload !== 'object') return;
      var type = item.type;
      var ym;
      var roomId;
      var query;
      var stayDate;
      var matched;
      if (type === 'settlement_published' || type === 'settlement_revised') {
        ym = this.parseYearMonth(payload.year, payload.month);
        if (!ym) return;
        this.$router.push({
          path: '/owner/settlement',
          query: { year: ym.year, month: ym.month }
        });
        return;
      }
      if (type === 'market_report' || type === 'kyoran_news') {
        ym = this.parseYearMonth(payload.year, payload.month);
        if (!ym) return;
        this.openPubMonthBoard(type, ym.year, ym.month);
        return;
      }
      if (type === 'owner_stay_result') {
        roomId = parseInt(payload.room_id, 10);
        if (!isFinite(roomId) || roomId <= 0) return;
        query = { room_id: roomId };
        stayDate = payload.stay_date ? String(payload.stay_date) : '';
        matched = /^(\d{4})-(\d{2})-(\d{2})/.exec(stayDate);
        if (matched) {
          ym = this.parseYearMonth(matched[1], matched[2]);
          if (ym) {
            query.cal_year = ym.year;
            query.cal_month = ym.month;
          }
        }
        this.$router.push({ path: '/owner', query: query });
      }
    },
    onLogout: function () {
      localStorage.removeItem('_landlord');
      if (window.S && S.remove) S.remove('_landlord');
      if (axios.defaults.headers.common) {
        delete axios.defaults.headers.common.Token;
      }
      location.replace('/#/signin');
    },
    goStay: function () {
      if (this.$route.path !== '/owner') {
        this.$router.push('/owner');
      }
    },
    goProfile: function () {
      if (this.$route.path !== '/owner/profile') {
        this.$router.push('/owner/profile');
      }
    },
    openNotice: function (title, body) {
      this.noticeTitle = title;
      this.noticeBody = body;
      this.ui.notice = true;
    },
    onMockTrigger: function (key) {
      if (key === 'account-menu') {
        this.ui.accountMenu = true;
      } else if (key === 'notice-panel') {
        this.ui.noticePanel = true;
      } else if (key === 'stay-sent') {
        this.openNotice('通知', '試泊申請を送信しました');
      } else if (key === 'owner-stop') {
        this.openNotice('通知', '〇〇邸は所有者の変更により\n2026年6月20日より運営状況の更新が停止します');
      } else if (key === 'bank-confirm') {
        this.confirmBody = 'この変更は請求書の\nオーナーの口座の表示に関わります\n本当に変更しますか？';
        this.ui.confirm = true;
      } else if (key === 'profile-person') {
        this.$router.push({ path: '/owner/profile', query: { mock: '1' } });
      } else if (key === 'profile-corp') {
        this.$router.push({ path: '/owner/profile', query: { mock: 'corp' } });
      } else if (key === 'month-board') {
        this.monthBoardLive = false;
        this.monthBoardFocusYear = 0;
        this.monthBoardFocusMonth = 0;
        this.ui.monthBoard = true;
      } else if (key === 'download-done') {
        this.openNotice('通知', 'ダウンロードが完了しました');
      } else if (key === 'empty-rooms') {
        mockData.emptyRooms = true;
        this.$eventBus.$emit('owner-mock-empty-rooms');
      } else if (key === 'empty-settlement') {
        mockData.settlementPublished = false;
        this.$eventBus.$emit('owner-mock-settlement-empty');
      } else if (key === 'collapse-rooms') {
        this.$eventBus.$emit('owner-mock-collapse-rooms');
      } else if (key === 'expand-rooms') {
        this.$eventBus.$emit('owner-mock-expand-rooms');
      } else if (key === 'open-contract') {
        this.$router.push('/owner/contract');
      } else if (key === 'settlement-data') {
        mockData.settlementPublished = true;
        this.$eventBus.$emit('owner-mock-settlement-data');
      } else if (key === 'settlement-empty') {
        mockData.settlementPublished = false;
        this.$eventBus.$emit('owner-mock-settlement-empty');
      }
    }
  }
};
